import Colors from 'assets/Colors.js';
import NoneBarIcon from 'components/icons/NoneBarIcon';
import s from './styles';

function ColorSelector({ handleChange }) {
  return (
    <s.ColorsContainer>
      <s.NoColorContainer onClick={() => handleChange(null)}>
        <NoneBarIcon />
      </s.NoColorContainer>
      <s.ColorContainer
        onClick={() => handleChange(Colors.BLUE)}
        color={Colors.BLUE}
      />
      <s.ColorContainer
        onClick={() => handleChange(Colors.GREEN)}
        color={Colors.GREEN}
      />
      <s.ColorContainer
        onClick={() => handleChange(Colors.PURPLE)}
        color={Colors.PURPLE}
      />
      <s.ColorContainer
        onClick={() => handleChange(Colors.PINK)}
        color={Colors.PINK}
      />
      <s.ColorContainer
        onClick={() => handleChange(Colors.ORANGE)}
        color={Colors.ORANGE}
      />
      <s.ColorContainer
        onClick={() => handleChange(Colors.YELLOW)}
        color={Colors.YELLOW}
      />
      <s.ColorContainer
        onClick={() => handleChange(Colors.GREY)}
        color={Colors.GREY}
      />
    </s.ColorsContainer>
  );
}

export default ColorSelector;
